import { Alert, AlertTitle, Box, Card, CardContent, CardActions, Chip, Collapse, Fab, Grid, List, ListItemButton, ListItemText, Paper, TextField, Typography, Button, CircularProgress, Theme } from "@mui/material";
import { useCallback, useContext, useEffect, useState } from "react";

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import MessageIcon from '@mui/icons-material/Message';

import OrderInterface from "../../interfaces/OrderInterface";

import OrderService from "../../services/order.service";
import AuthService from "../../services/auth.service";
import moment from "moment";
import 'moment/locale/pt-br';
import statusProps from "../../utils/StatusUtils";
import useInterval from "../../utils/useInterval";
import UserMessageInterface from "../../interfaces/UserMessageInterface";
import functionsUser from "../../services/user.service";
import { grey } from "@mui/material/colors";
import AppContext from "../../contexts/AppContext";
import { useTheme } from "@mui/styles";

moment.locale('pt-br');

const OrdersChatList = () => {
	const theme: Theme = useTheme();
	const appContext = useContext(AppContext);
	const [open, setOpen] = useState<boolean>(false);
	const [orders, setOrders] = useState<OrderInterface[]>();
	const [order, setOrder] = useState<OrderInterface>();
	const [selectedIndex, setSelectedIndex] = useState<string>("");
	const [messages, setMessages] = useState<UserMessageInterface[]>();
	const [newMessage, setNewMessage] = useState<string>("");
	const [loadingOrders, setLoadingOrders] = useState<boolean>(true);

	const handleClick = () => {
		setOpen(!open);
	};

	const handleListItemClick = (
		event: React.MouseEvent<HTMLDivElement, MouseEvent>,
		index: string,
	) => {
		setSelectedIndex(index);
		let orderAux = orders?.find((order) => { return order.id === index });
		setOrder(orderAux);
	};

	const fetchOrders = useCallback(() => {
		if (appContext?.userID !== undefined && appContext.userID !== null && appContext?.userID !== "") {
			// setLoadingOrders(true);
			OrderService.getUserOrders(appContext?.userID ?? "")
				.then((response) => {
					// console.log(response.data);
					setOrders(response.data);
					setLoadingOrders(false);
					// setLoadingOrders(false);
				}).catch((error) => {
					if (JSON.stringify(error).includes("401")) {
						AuthService.Logout();
					}

					console.log(error);
					// setLoadingOrders(false);
				})
		}
	}, [appContext]);

	useEffect(() => {
		fetchOrders();
	}, [fetchOrders]);

	useInterval(() => {
		fetchOrders();
	}, 5000);

	// useEffect(() => {
	// 	console.log(theme);
	// }, [theme]);

	const fetchMessages = (id: string) => {
		functionsUser.getOrderMessages(id)
			.then((response) => {
				// console.log(response.data);
				setMessages(response.data);
				// console.log(response.data);
			}).catch((error) => {
				console.log(error);
			})
	};

	const sendMessage = (id: string) => {
		functionsUser.sendOrderMessage(id, {
			senderID: order?.userID ?? "",
			recipientID: order?.deliveryManID ?? "",
			orderID: id,
			message: newMessage,
			read: false,
			date: new Date(),
			id: ""
		}).then((response) => {
			fetchMessages(id);
			setNewMessage("");
		}).catch((error) => {
			console.log(error);
		})
	};

	useEffect(() => {
		if (selectedIndex !== "") {
			fetchMessages(selectedIndex);
		}
	}, [selectedIndex]);

	useInterval(() => {
		if (selectedIndex !== "") {
			fetchMessages(selectedIndex);
		}
	}, 5000);

	return (
		<>
			<div
				style={{
					position: 'fixed',
					right: '5px',
					bottom: '5px',
					maxWidth: '100vw',
					width: open ? '700px' : '165px',
					zIndex: 1000
				}}
			>
				<List>
					<ListItemButton
						onClick={handleClick}
						style={{
							// backgroundColor: "#666"
							backgroundColor: theme?.palette?.primary?.main,
							color: theme?.palette?.primary?.contrastText
						}}
					// color={theme?.palette?.primary?.main}
					>
						<ListItemText primary={"Pedidos ativos"} />
						{open ? <ExpandLess /> : <ExpandMore />}
					</ListItemButton>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Card elevation={10} style={{ padding: 0, margin: 0 }}>
							<CardContent style={{ padding: 0, margin: 0 }}>
								<Grid container>
									<Grid item lg={4} md={4} xs={4} style={{ overflowY: 'scroll', height: 350 }}>
										{loadingOrders ? <>
											<Box
												style={{
													display: 'flex',
													justifyContent: 'center',
													alignContent: 'center',
													alignItems: 'center',
													height: 300
												}}
											>
												<CircularProgress />
											</Box>
										</> : <>
											<List component="nav" aria-label="main mailbox folders" style={{ padding: 0, margin: 0 }}>
												{orders !== undefined && orders?.length > 0 ? <>
													{orders?.map((order) => (
														<ListItemButton
															key={order.id}
															selected={selectedIndex === order.id}
															onClick={(event) => handleListItemClick(event, order.id ?? "")}
														>
															<ListItemText
																primary={"De " + order.originAddress?.formatted_address + " para " + order.toAddress?.formatted_address}
																primaryTypographyProps={{
																	fontSize: 10
																}}
																secondary={
																	<Chip
																		variant={"outlined"}
																		size={"small"}
																		label={statusProps.filter(function (status) { return status.status === order.status })[0].text}
																		color={"primary"}
																		style={{
																			backgroundColor: statusProps.filter(function (status) { return status.status === order.status })[0].backgroundColor,
																			color: statusProps.filter(function (status) { return status.status === order.status })[0].textColor,
																			borderWidth: 0
																		}}
																	/>
																}
															/>
														</ListItemButton>
													))}
												</> : <>
													<Box
														style={{
															padding: 16
														}}
													>
														<Alert variant={"standard"} severity={"info"}>
															<AlertTitle>Aviso</AlertTitle>
															Nenhum pedido disponível
														</Alert>
													</Box>
												</>}
											</List>
										</>}
									</Grid>
									<Grid item lg={8} md={8} xs={8} style={{ flexDirection: 'column', height: 350 }}>
										<Card style={{ height: '100%' }}>
											{selectedIndex !== "" && order !== undefined ? <>
												<CardContent
													style={{
														backgroundColor: '#fff',
														overflow: 'scroll',
														overflowX: 'hidden',
														padding: 0,
														flex: 1,
														height: 270
													}}
												>
													<Box
														style={{
															backgroundColor: '#EEE',
															padding: 8,
															flexDirection: 'row',
															textAlign: 'center',
															flex: 1
														}}
													>
														<Typography align={"center"} variant={"caption"} component={"p"}>
															Transportador: {(order !== undefined && order?.deliveryManID !== undefined && order.deliveryMan !== undefined && order.deliveryMan[0] !== undefined) ? order?.deliveryMan[0]?.name : "-/-"}
														</Typography>
														<Typography align={"center"} variant={"caption"} component={"p"}>
															Preço: R$ {order?.price.toFixed(2)} - Previsão de entrega: {moment(order.deliveryForecastTime).format("DD/MM/YYYY - HH:mm")}
														</Typography>
														<Button
															size={"small"}
															href={`/order/${order?.id}`}
														>
															Ver mais
														</Button>
													</Box>
													{messages !== undefined && messages?.length > 0 ? <>
														{messages.map((message: UserMessageInterface) => (
															<>
																{message.senderID === order?.userID ? <>
																	<Box
																		style={{
																			marginTop: 8,
																			marginBottom: 8,
																			marginRight: 16,
																			textAlign: 'right'
																		}}
																	>
																		<Typography variant={"caption"} component={"p"} style={{ fontSize: 10, color: "#999" }}>
																			{moment(message.date).fromNow()}
																		</Typography>
																		<Paper
																			style={{
																				display: 'inline-block',
																				backgroundColor: "#c8facd",
																				color: grey[900],
																				maxWidth: '75%',
																				padding: 8,
																				paddingLeft: 12,
																				paddingRight: 12,
																				borderRadius: 4,
																			}}
																			elevation={0}
																		>
																			{message.message}
																		</Paper>

																	</Box>
																</> : <>
																	<Box
																		style={{
																			marginTop: 8,
																			marginBottom: 8,
																			marginLeft: 16,
																			textAlign: 'left'
																		}}
																	>
																		<Typography variant={"caption"} component={"p"} style={{ fontSize: 10, color: "#999" }}>
																			{moment(message.date).fromNow()}
																		</Typography>
																		<Paper
																			style={{
																				display: 'inline-block',
																				backgroundColor: grey[200],
																				color: grey[900],
																				maxWidth: '75%',
																				padding: 8,
																				paddingLeft: 12,
																				paddingRight: 12,
																				borderRadius: 4
																			}}
																			elevation={0}
																		>
																			{message.message}
																		</Paper>
																	</Box>
																</>}
															</>
														))}
													</> : <>
														<Box
															style={{
																padding: 16
															}}
														>
															<Alert variant={"standard"} severity={"info"}>
																<AlertTitle>Aviso</AlertTitle>
																Você ainda não conversou com esse transportador.
															</Alert>
														</Box>
													</>}
												</CardContent>
												{order.status === "FINISHED" || order.status === "CANCELED" ? <></> : <>
													<CardActions
														style={{
															backgroundColor: '#FFF',
															flexDirection: 'row',
															height: 80
														}}
													>
														<TextField
															label={"Sua mensagem"}
															placeholder={"Digite sua mensagem"}
															fullWidth
															variant={"outlined"}
															style={{
																backgroundColor: "#FFF"
															}}
															value={newMessage}
															onChange={(event) => {
																setNewMessage(event.target.value);
															}}
															onKeyPress={(ev) => {
																// console.log(`Pressed keyCode ${ev.key}`);
																if (ev.key === 'Enter') {
																	// Do code here
																	ev.preventDefault();
																	if (newMessage !== "") {
																		sendMessage(selectedIndex);
																	}
																}
															}}
															disabled={order.status === "FINISHED" || order.status === "CANCELED"}
														/>
														<Fab
															color="secondary"
															aria-label="add"
															disabled={newMessage === "" || order.status === "FINISHED" || order.status === "CANCELED"}
															onClick={() => {
																sendMessage(selectedIndex);
															}}
															style={{
																marginLeft: 8
															}}
														>
															<MessageIcon />
														</Fab>
													</CardActions>
												</>}
											</> : <>
												<CardContent>
													<Alert variant={"standard"} severity={"info"}>
														<AlertTitle>Aviso</AlertTitle>
														Selecione um pedido para conversar com o transportador.
													</Alert>
												</CardContent>
											</>}
										</Card>
									</Grid>
								</Grid>
							</CardContent>
						</Card>
					</Collapse>
				</List>
			</div>
		</>
	)
};

export default OrdersChatList;